export default "__VITE_ASSET__Dpxzguyg__"